import { Box, Button, Grid, Typography } from "@mui/material"
import PaperBox from "components/PaperBox"
import { allRoutes } from "generated/routes"
import { useTranslation } from "react-i18next"
import { NavLink } from "react-router-dom"
import { StyledButtonGrid, StyledImageGrid } from "./ExaminationMiniInfoCard.styled"

export const ExaminationMiniInfoCard = (props) => {
  const { item } = props
  const styleProps = {
    image: "/assets/learning/card_".concat(item.examinationType).concat(".jpg")
  }

  const { t } = useTranslation()

  return (
    <PaperBox p={0} m={0} {...props}>
      <Grid container direction="row" justifyContent="space-between">
        <StyledImageGrid {...styleProps} item xs={12}></StyledImageGrid>

        <StyledButtonGrid item xs={12}>
          <Typography variant="paragraphLarge">
            {t("learning.titles.getStarted", "Ready to get started?")}
          </Typography>
          <Box mt={2} mb={3}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              component={NavLink}
              to={allRoutes.LearningUserExamsExamination(item.userExaminationId)}>
              {t("learning.admin.overview.buttons.startCourse", "Start course")}
            </Button>
            <Typography px={3} mt={3} variant="bodySmall" color="textSecondary">
              {t(
                "learning.titles.save_on_submit",
                'The answers are only saved when you click "submit" on the last page.'
              )}{" "}
            </Typography>
          </Box>
        </StyledButtonGrid>
      </Grid>
    </PaperBox>
  )
}
